export default {"src":"/_next/static/media/success.4a5fdda8.svg","height":34,"width":33,"blurWidth":0,"blurHeight":0};